import { z } from 'zod';

/** Trip model (PRD → Core objects → Trip; gitaumoses4/chukua#41): one truck, one trailer, one driver, one leg of a job. */

export const TRIP_LEG_TYPES = ['delivery', 'empty_return', 'transfer'] as const;
export type TripLegType = (typeof TRIP_LEG_TYPES)[number];

/** Only `pending` is reachable until dispatch assignment lands; the rest of the lifecycle joins this list with it. */
export const TRIP_STATUSES = ['pending'] as const;
export type TripStatus = (typeof TRIP_STATUSES)[number];

/**
 * One trip's cargo, for the leg it names: the containers it carries (container jobs) or a loose
 * quantity (loose jobs). Which of the two a job needs depends on its job type, so that cross-check
 * is `trip-planning.policy.ts`'s, not this schema's. Several containers make one trip; three
 * trips for three containers are three calls.
 */
export const createTripInputSchema = z
  .object({
    legType: z.enum(TRIP_LEG_TYPES),
    containerIds: z.array(z.uuid()).min(1).max(20).optional(),
    quantity: z.number().int().positive().optional(),
  })
  .refine((input) => !(input.containerIds && input.quantity !== undefined), { message: 'A trip carries containers or a loose quantity, not both' })
  .refine((input) => !input.containerIds || new Set(input.containerIds).size === input.containerIds.length, { message: 'A container can only be listed once' });
export type CreateTripInput = z.infer<typeof createTripInputSchema>;
